import {
    createApp
} from 'vue';
import App from './App.vue';
import router from './router';
import './assets/styles.css';

async function init() {
    try {
        const app = createApp(App);
        app.use(router);
        app.mount('#app');
    } catch (error) {
        // do nothing
    }
}

init();